/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_AccionAsync as AccionAsync,
  rec_Ai as Ai,
  rec_Ar as Ar,
  rec_Componente_zO_122_79 as Componente_zO_122_79,
  rec_FO as FO,
  rec_Gi as Gi,
  rec_Gr as Gr,
  rec_IO as IO,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_SelectorMultiple as SelectorMultiple,
  rec_Sn as Sn,
  rec_Ti as Ti,
  rec_Vo as Vo,
  rec_api as api,
  rec_fS as fS,
  rec_nS as nS,
  rec_ra as ra,
  rec_wi as wi,
} from "../../runtime/index.jsx";
export function DetalleEstrategia(e) {
  let t = (0, ReactCompiler.c)(66),
    {
      e: n,
      abierta: r,
      onAlternar: i,
      editable: a,
      proyectosDeLaUnidad: o,
      estrategias: s,
      onEditar: c,
      onAgregar: l,
      onSacar: u,
    } = e,
    f;
  t[0] === n.estado
    ? (f = t[1])
    : ((f = FO(n.estado)), (t[0] = n.estado), (t[1] = f));
  let p = f,
    m = n.avance,
    h = n.estado === `CANCELADA`,
    [_, v] = (0, React.useState)(``),
    [y, b] = (0, React.useState)(null),
    x;
  t[2] === s
    ? (x = t[3])
    : ((x = (e) => s.find((t) => t.id === e)?.nombre), (t[2] = s), (t[3] = x));
  let S = x,
    C;
  if (t[4] !== n.id || t[5] !== S || t[6] !== o) {
    let e;
    t[8] === n.id
      ? (e = t[9])
      : ((e = (e) => e.estrategiaId !== n.id), (t[8] = n.id), (t[9] = e));
    let r;
    (t[10] === S
      ? (r = t[11])
      : ((r = (e) => ({
          value: String(e.id),
          label: e.estrategiaId
            ? `${e.nombre} (hoy en «${S(e.estrategiaId) ?? `otra`}»)`
            : e.nombre,
        })),
        (t[10] = S),
        (t[11] = r)),
      (C = o.filter(e).map(r)),
      (t[4] = n.id),
      (t[5] = S),
      (t[6] = o),
      (t[7] = C));
  } else C = t[7];
  let w = C,
    T;
  t[12] !== n.id || t[13] !== y
    ? ((T = async function () {
        if (y) {
          b(null);
          return;
        }
        try {
          b(
            await api(`/estrategias/${n.id}/historial`, {
              sinCache: !0,
            }),
          );
        } catch {
          b([]);
        }
      }),
      (t[12] = n.id),
      (t[13] = y),
      (t[14] = T))
    : (T = t[14]);
  let E = T,
    D;
  t[15] !== n.fechaInicio || t[16] !== n.fechaMeta
    ? ((D =
        n.fechaInicio || n.fechaMeta
          ? `${n.fechaInicio ? fS(n.fechaInicio) : `…`} → ${n.fechaMeta ? fS(n.fechaMeta) : `…`}`
          : null),
      (t[15] = n.fechaInicio),
      (t[16] = n.fechaMeta),
      (t[17] = D))
    : (D = t[17]);
  let O = D,
    k = `rounded-xl border border-(--border) bg-(--bg) ${h ? `opacity-70` : ``}`,
    A;
  t[18] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((A = (
        <Gi
          className={`h-4 w-4 shrink-0 text-(--accent)`}
          aria-hidden={`true`}
        />
      )),
      (t[18] = A))
    : (A = t[18]);
  let j;
  t[19] === n.nombre
    ? (j = t[20])
    : ((j = (
        <span
          className={`min-w-0 flex-1 truncate font-medium text-(--text-h)`}
          children={n.nombre}
        />
      )),
      (t[19] = n.nombre),
      (t[20] = j));
  let M = `rounded-full px-2 py-0.5 text-[11px] ${p.clase}`,
    N;
  t[21] !== p.label || t[22] !== M
    ? ((N = <span className={M} children={p.label} />),
      (t[21] = p.label),
      (t[22] = M),
      (t[23] = N))
    : (N = t[23]);
  let P = `h-4 w-4 shrink-0 text-(--text) transition sm:order-last ${r ? `rotate-180` : ``}`,
    F;
  t[24] === P
    ? (F = t[25])
    : ((F = <Ar className={P} aria-hidden={`true`} />),
      (t[24] = P),
      (t[25] = F));
  let I;
  t[26] === m.proyectos
    ? (I = t[27])
    : ((I = IO(m.proyectos, `proyecto`, `proyectos`)),
      (t[26] = m.proyectos),
      (t[27] = I));
  let L =
      m.totalTareas > 0
        ? ` · ${m.completadas} de ${m.totalTareas} tareas terminadas`
        : ``,
    R;
  t[28] !== I || t[29] !== L
    ? ((R = <span children={[I, L]} />), (t[28] = I), (t[29] = L), (t[30] = R))
    : (R = t[30]);
  let z;
  t[31] === m.atrasadas
    ? (z = t[32])
    : ((z = m.atrasadas > 0 && (
        <span
          className={`font-medium text-(--error-texto)`}
          children={IO(m.atrasadas, `atrasada`, `atrasadas`)}
        />
      )),
      (t[31] = m.atrasadas),
      (t[32] = z));
  let ee;
  t[33] !== m.avance || t[34] !== m.totalTareas
    ? ((ee = m.totalTareas > 0 && (
        <span
          className={`flex items-center gap-1.5`}
          children={[
            <span
              className={`h-1.5 w-16 overflow-hidden rounded-full bg-(--panel)`}
              children={
                <span
                  className={`block h-full rounded-full bg-(--accent)`}
                  style={{
                    width: `${m.avance}%`,
                  }}
                />
              }
            />,
            <span className={`text-(--text-h)`} children={[m.avance, `%`]} />,
          ]}
        />
      )),
      (t[33] = m.avance),
      (t[34] = m.totalTareas),
      (t[35] = ee))
    : (ee = t[35]);
  let te;
  t[36] !== R || t[37] !== z || t[38] !== ee
    ? ((te = (
        <span
          className={`flex basis-full flex-wrap items-center gap-x-3 gap-y-1 pl-7 text-xs text-(--text) sm:basis-auto sm:pl-0`}
          children={[R, z, ee]}
        />
      )),
      (t[36] = R),
      (t[37] = z),
      (t[38] = ee),
      (t[39] = te))
    : (te = t[39]);
  let B;
  t[40] !== r ||
  t[41] !== i ||
  t[42] !== N ||
  t[43] !== F ||
  t[44] !== te ||
  t[45] !== j
    ? ((B = (
        <button
          type={`button`}
          onClick={i}
          aria-expanded={r}
          className={`flex w-full flex-wrap items-center gap-x-3 gap-y-1 rounded-xl px-3 py-2.5 text-left text-sm transition hover:bg-(--accent-bg) ${Vo}`}
          children={[A, j, N, F, te]}
        />
      )),
      (t[40] = r),
      (t[41] = i),
      (t[42] = N),
      (t[43] = F),
      (t[44] = te),
      (t[45] = j),
      (t[46] = B))
    : (B = t[46]);
  let V;
  t[47] !== r ||
  t[48] !== h ||
  t[49] !== n.descripcion ||
  t[50] !== n.proyectos ||
  t[51] !== n.responsableNombre ||
  t[52] !== a ||
  t[53] !== _ ||
  t[54] !== O ||
  t[55] !== y ||
  t[56] !== l ||
  t[57] !== c ||
  t[58] !== u ||
  t[59] !== w ||
  t[60] !== E
    ? ((V = r && (
        <div
          className={`animar-entrada flex flex-col gap-3 border-t border-(--border) px-3 py-3`}
          children={[
            <div
              className={`flex flex-wrap items-start gap-x-4 gap-y-1 text-xs text-(--text)`}
              children={[
                <span
                  children={[
                    `Responsable: `,
                    <b
                      className={`font-medium text-(--text-h)`}
                      children={n.responsableNombre ?? `sin responsable`}
                    />,
                  ]}
                />,
                O && <span children={O} />,
                a && (
                  <span
                    className={`ml-auto flex gap-1`}
                    children={
                      <AccionAsync
                        variante={`chico`}
                        icono={wi}
                        onClick={c}
                        children={`Editar`}
                      />
                    }
                  />
                ),
              ]}
            />,
            n.descripcion && (
              <p
                className={`whitespace-pre-line text-sm text-(--text-h)`}
                children={n.descripcion}
              />
            ),
            n.proyectos.length > 0 ? (
              <ul
                className={`flex flex-col gap-1`}
                children={n.proyectos.map((e) => (
                  <li
                    key={e.id}
                    className={`flex items-center gap-1`}
                    children={[
                      <Sn
                        to={`/proyectos/${e.id}`}
                        className={`flex min-w-0 flex-1 flex-wrap items-center gap-2 rounded-lg border border-(--border) px-3 py-2 text-sm transition hover:bg-(--accent-bg)`}
                        children={[
                          <Gr
                            className={`h-4 w-4 shrink-0 text-(--text)`}
                            aria-hidden={`true`}
                          />,
                          <span
                            className={`h-2.5 w-2.5 shrink-0 rounded-full`}
                            style={{
                              background: nS(e.color),
                            }}
                          />,
                          <span
                            className={`min-w-0 flex-1 truncate text-(--text-h)`}
                            children={e.nombre}
                          />,
                          <span
                            className={`shrink-0 text-[11px] text-(--text)`}
                            children={[
                              e.totalTareas > 0
                                ? `${e.completadas}/${e.totalTareas} · ${e.avance}%`
                                : `sin tareas`,
                              e.atrasadas > 0 && (
                                <span
                                  className={`text-(--error-texto)`}
                                  children={[
                                    ` · `,
                                    IO(e.atrasadas, `atrasada`, `atrasadas`),
                                  ]}
                                />
                              ),
                            ]}
                          />,
                        ]}
                      />,
                      a && (
                        <button
                          type={`button`}
                          onClick={() => u(e)}
                          aria-label={`Sacar ${e.nombre} de la estrategia`}
                          title={`Sacar de la estrategia`}
                          className={`rounded-lg p-2 text-(--text) hover:bg-(--accent-bg) hover:text-(--text-h) transition duration-150 ease-(--curva) active:scale-[0.97] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--accent-border) focus-visible:ring-offset-1 focus-visible:ring-offset-(--bg) disabled:cursor-not-allowed disabled:opacity-50 disabled:active:scale-100`}
                          children={(0, JSXRuntime.jsx)(ra, {
                            className: `h-4 w-4`,
                          })}
                        />
                      ),
                    ]}
                  />
                ))}
              />
            ) : (
              <p
                className={`text-sm text-(--text)`}
                children={`Todavía no tiene proyectos.`}
              />
            ),
            a && !h && w.length > 0 && (
              <div
                className={`flex flex-wrap items-center gap-2`}
                children={[
                  <SelectorMultiple
                    value={_}
                    onChange={v}
                    opciones={w}
                    placeholder={`Elegir un proyecto de la unidad…`}
                    className={`min-w-0 flex-1`}
                  />,
                  <AccionAsync
                    variante={`chico`}
                    icono={Ti}
                    disabled={!_}
                    onClick={async () => {
                      (await l(Number(_)), v(``));
                    }}
                    children={`Agregar`}
                  />,
                ]}
              />
            ),
            <button
              type={`button`}
              onClick={E}
              className={`flex w-fit items-center gap-1 text-xs text-(--text) hover:text-(--accent) transition duration-150 ease-(--curva) active:scale-[0.97] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--accent-border) focus-visible:ring-offset-1 focus-visible:ring-offset-(--bg) disabled:cursor-not-allowed disabled:opacity-50 disabled:active:scale-100`}
              children={[
                <Ai className={`h-3.5 w-3.5`} />,
                ` `,
                y ? `Ocultar historial` : `Ver historial`,
              ]}
            />,
            y &&
              (y.length === 0 ? (
                <p
                  className={`text-xs text-(--text)`}
                  children={`Sin movimientos.`}
                />
              ) : (
                <ul
                  className={`flex max-h-48 flex-col gap-1 overflow-y-auto text-xs text-(--text)`}
                  children={y.map(Componente_zO_122_79)}
                />
              )),
          ]}
        />
      )),
      (t[47] = r),
      (t[48] = h),
      (t[49] = n.descripcion),
      (t[50] = n.proyectos),
      (t[51] = n.responsableNombre),
      (t[52] = a),
      (t[53] = _),
      (t[54] = O),
      (t[55] = y),
      (t[56] = l),
      (t[57] = c),
      (t[58] = u),
      (t[59] = w),
      (t[60] = E),
      (t[61] = V))
    : (V = t[61]);
  let H;
  return (
    t[62] !== B || t[63] !== V || t[64] !== k
      ? ((H = <li className={k} children={[B, V]} />),
        (t[62] = B),
        (t[63] = V),
        (t[64] = k),
        (t[65] = H))
      : (H = t[65]),
    H
  );
}
